<template>
  <el-dialog :title="$t('offering.selectCourse')"
             :visible.sync="dialogVisible"
             :close-on-click-modal="false"
             append-to-body
             :before-close="closeCourseDlg"
             width="90%">
    <div style="margin-top: 5px;">
      <el-row :gutter="10">
        <el-col :span="18">
          <el-card class="box-card">
            <el-form label-position="center"
                     label-width="80px"
                     :model="dataForm"
                     ref="dataForm"
                     @keyup.enter.native="querySiteInfo()"
                     @submit.native.prevent>
              <el-row :gutter="0">
                <!-- 第一行 -->
                <el-col :span="6">
                  <!-- 品牌 -->
                  <el-form-item :label="$t('couse.brand')"
                                style="width: 98%!important;"
                                prop="courseBrand">
                    <el-select v-model="brandQuery"
                              multiple
                              collapse-tags
                              :placeholder="$t('course.select')">
                      <el-option v-for="(item,index) in courseBrandArr"
                                :key="index"
                                :label="item.name"
                                :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <!-- 课程分类 -->
                  <el-form-item :label="$t('couse.coursecatalogid')"
                                style="width: 98%!important;">
                    <catalog-tree @cateloglist="cateloglist"
                                :defaultProps="courseCatalogPropsz"
                                :showArray="showCourseCatalogList"
                                :showValue="showCourseCatalogValue"
                                :url="courseCatalogUrl"
                                :isSelect=false
                                :status="'classStatus'"
                                ref="catalogtree"></catalog-tree>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <!-- 课程类型 -->
                  <el-form-item :label="$t('couse.coursekind1')"
                                label-width="110px"
                                style="width: 112% !important;"
                                prop="coursekind">
                    <el-select v-model="dataForm.coursekind"
                              filterable
                              clearable
                              :placeholder="$t('course.select')">
                      <el-option v-for="(item,index) in newcourseKind"
                                :key="index"
                                :label="item.name"
                                :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="3"
                        class="query-button">
                  <el-form-item label-width="40px">
                    <el-button style="margin-bottom: 7px"
                               type="primary"
                               @click="querySiteInfo()">{{ $t('query') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <!--活动状态-->
              <el-row>
                <!-- 课程名称 -->
                <el-col :span="6">
                  <el-form-item :label="$t('couse.coursename')"
                                style="width: 98%!important;">
                    <el-input v-model="dataForm.coursename"
                              :placeholder="$t('course.plsInputCodeorName')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <!-- 课程状态 -->
                  <el-form-item :label="$t('couse.coursestatus')"
                                style="width: 98%!important;"
                                prop="coursestatus">
                    <el-select v-model="dataForm.coursestatus"
                              filterable
                              clearable
                              :placeholder="$t('course.select')">
                      <el-option v-for="(item,index) in newcoursestatus"
                                :key="index"
                                :label="item.name"
                                :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 是否限制学习-->
                <el-col :span="6">
                  <el-form-item :label="$t('couse.limitvisiableflag')"
                                style="width: 112% !important;"
                                label-width="110px">
                    <el-select v-model="dataForm.limitvisiableflag"
                                filterable
                                clearable
                                :placeholder="$t('course.select')">
                      <el-option v-for="(item,index) in newcourseProjectCF"
                                  :key="index"
                                  :label="item.name"
                                  :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="3"
                        class="query-button">
                  <el-form-item label-width="40px">
                    <el-button class="el-back"
                               type="info"
                               @click="resetCourseData()">{{ $t('reset') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="dataBox"
                 id="gridBox">
              <el-table :data="dataList"
                  @select="selectRedio"
                  @select-all="selectAll"
                  border
                  :header-cell-style="{background: '#f1f1f1'}"
                  v-loading="dataListLoading"
                  ref="coursePlanTable"
                  style="width: 100%;">
                <el-table-column type="selection"
                                align="center"
                                width="50px">
                </el-table-column>
                <!-- 课程代码 -->
                <el-table-column prop="courseCode"
                                :label="$t('offeringcd.cousercode')"
                                header-align="center"
                                :show-overflow-tooltip="true"
                                align="center"></el-table-column>
                <!-- 课程中文名称 -->
                <el-table-column prop="courseNameCn"
                                :label="$t('offeringcd.cousernamecn')"
                                header-align="center"
                                :show-overflow-tooltip="true"
                                align="center">
                </el-table-column>
                <!-- 课程英文缩写 -->
                <el-table-column prop="courseNameEn"
                                :label="$t('offeringcd.cousernameen')"
                                header-align="center"
                                :show-overflow-tooltip="true"
                                align="center">
                </el-table-column>
                <!-- 课程时长(天) -->
                <el-table-column prop="courseDays"
                                :label="$t('offeringcd.courseDays')"
                                header-align="center"
                                :show-overflow-tooltip="true"
                                align="center">
                </el-table-column>
                <!-- 课程团队分类 -->
                <el-table-column prop="courseTeamCatalogName"
                                :label="$t('offeringcd.couserTeamcatalog')"
                                header-align="center"
                                :show-overflow-tooltip="true"
                                align="center">
                </el-table-column>
                <!-- 课程分类 -->
                <el-table-column prop="courseCatalogName"
                                :label="$t('offeringcd.cousercatalog')"
                                header-align="center"
                                :show-overflow-tooltip="true"
                                align="center">
                </el-table-column>
                <!-- 课程类型 -->
                <el-table-column prop="courseKind"
                                :label="$t('offeringcd.cousertype')"
                                header-align="center"
                                :show-overflow-tooltip="true"
                                :formatter="coursekindformat"
                                align="center">
                </el-table-column>
                <!-- 课程状态 -->
                <el-table-column prop="courseStatus"
                                :label="$t('offeringcd.couserstate')"
                                header-align="center"
                                :show-overflow-tooltip="true"
                                :formatter="coursestatusformat"
                                align="center">
                </el-table-column>
              </el-table>
              <el-pagination @size-change="pageSizeChangeHandle"
                            @current-change="pageCurrentChangeHandle"
                            :current-page="page"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="limit"
                             style="text-align: right"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
              </el-pagination>
              <br>
            </div>
          </el-card>
        </el-col>

        <!--已选场地-->
        <el-col :span="6">
          <el-card>
            <div>
              <el-form :model="dataForms"
                       ref="dataForms">
                <div class="selectBox">
                  <p class="dataBox">{{$t('couse.selectedCourse')}}</p>
                  <div class="btns">
                    <el-button size="mini"
                               type="primary"
                               @click="closeCourseDlg">取 消</el-button>
                    <el-button size="mini"
                               type="primary"
                               style="margin-left: 5px"
                               @click="courseSelectBack">确 定</el-button>
                  </div>
                </div>
                <el-row :gutter="10">
                  <el-col v-for="tag in courseData"
                          :key="tag.courseNameCn">
                    <el-tag show-overflow-tooltip
                            style="margin-bottom: 10px;width: 250px;text-align: left"
                            :key="tag.courseNameCn"
                            @close="handleClose(tag)"
                            closable>
                      <div style="width:90%;float:left;overflow-x:hidden; overflow-y:hidden; word-break:keep-all; white-space:nowrap;">{{tag.courseNameCn}}</div>
                    </el-tag>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import AddressSelect from '@/components/address-select'
import mixinViewModule from '@/mixins/view-module'
import catalogTree from '@/components/learning/catalog-multiple/index'
import Vue from 'vue'
export default {
  mixins: [mixinViewModule],
  name: 'subordinate-site',
  props: {
    dialogVisible: Boolean,
    // true:单选；false：多选
    isSingleElection: {
      type: Boolean,
      default: false
    },
    selectCourseTable: {
      type: Array,
      required: false
    }
  },
  components: {
    AddressSelect,
    'catalog-tree': catalogTree
  },
  data () {
    let _this = this
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/learning/courseinfo/offeringpage',
        getDataListIsPage: true
      },
      selectRows: [],
      courseData: [],
      // 组织类型
      newcourseKinds: _this.enums['courseKind'],
      // 课程类型
      newcourseKind: _this.enums['courseKind'],
      // 品牌类型
      courseBrandArr: _this.enums['courseBrand'],
      // 是否 courseProjectCF
      newcourseProjectCF: _this.enums['courseProjectCF'],
      // 课程状态
      newcoursestatus: [{ code: '20', name: '已发布' }, { code: '30', name: '已下架' }],
      brandQuery: [],
      dataForm: {
        courseStatuslist: '20,30,80',
        courseBrand: [], // 品牌
        courseBaseId: '',
        courseCode: '',
        coursename: '',
        courseTeamCatalogSecond: ''
      },
      dataList: [],
      // 编辑面板标签对齐方式
      labelPosition: 'left',
      // 查询面板标签宽度
      queryLabelWidth: '70px',
      page: 1, // 当前页码
      limit: 10, // 每页数
      total: 0, // 总条数deleteURL
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      dataForms: {
        priority: ''
      },
      // 团队分类
      defaultProps: {
        children: 'children',
        label: 'treamCnName'
      },
      queryTreeUrl: '/rm/rpc/treamClassTree/list',
      // 课程分类树
      courseCatalogPropsz: {
        children: 'children',
        label: 'catalogNameCn',
        id: 'catalogId'
      },
      showCourseCatalogList: [],
      showCourseCatalogValue: '',
      courseCatalogUrl: '/learning/coursecatalog/list',
      allteamcatalog: _this.enums['catalogidList2']
    }
  },
  created () {
    debugger
    this.mixinViewModuleOptions.getDataListURL = '/learning/courseinfo/offeringpage'
    this.mixinViewModuleOptions.getDataListIsPage = true
    this.getprojectCourseFlagRole()
    this.getDataList()
    let resdata = this.dataList
    resdata.forEach(item => {
      item.checked = false
    })
    this.dataList = resdata
  },
  methods: {
    // 课程分类调用树
    cateloglist: function (data) {
      let catalogId = ''
      let catalogNameCn = ''
      data[0].data.forEach(rows => {
        catalogId = catalogId + rows.catalogId + ','
        catalogNameCn = catalogNameCn + rows.catalogNameCn + ','
      })
      this.dataForm.catalogId = catalogId
    },
    selectCourseClose () {
      this.$emit('selectCourseClose')
    },
    // 获取信息
    initSuborSite () {
      debugger
      console.log('initSuborSite')
      this.page = 1
      // 将已选场地清空
      this.courseData = []
      if (this.selectCourseTable && this.selectCourseTable.length > 0) {
        this.courseData = this.selectCourseTable
      }
      this.$refs['dataForm'] && this.$refs['dataForm'].resetFields()
      this.$refs.catalogtree && this.$refs.catalogtree.resetChecked()
      this.$refs.classRef && this.$refs.classRef.resetChecked()
      this.$refs.cityclassRef && this.$refs.cityclassRef.resetChecked()
      this.dataForm = {
        offeringcoursecode: 'offering',
        courseStatuslist: '20,30,80',
        courseBaseId: '',
        courseBrand: [], // 品牌
        courseCode: '',
        coursename: '',
        projectCourseFlag: ''
      }
      this.courseData = this.selectCourseTable
      console.log(this.selectCourseTable)
      console.log(this.courseData)
      this.brandQuery = []
      this.showCourseCatalogList = []
      this.showCourseCatalogValue = ''
      this.getDataList()
    },
    // 获取数据列表
    getDataList () {
      this.getprojectCourseFlagRole()
      this.getTeamRole()
      console.info(this.dataForm)
      this.dataForm.offeringcoursecode='offering'
      this.dataForm.courseStatuslist='20,30,80'
      if (this.brandQuery != null || this.brandQuery !== '') {
        this.dataForm.courseBrand = this.brandQuery + ''
      }
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
      if ('regionIds' in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = ''
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(',')
        }
      }
      this.dataListLoading = true
      this.$request.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...newDataForm
        }
      ).then((res, total, code, data) => {
        console.warn(data.result)
        this.dataListLoading = false
        let resultList = data.data.records
        this.dataList = resultList
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? parseInt(data.data.total, 10) : 0
        // 延迟加载
        this.$nextTick(() => {
          this.querSelect()
        })
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    selectAll (selection) {
      let _this = this
      if (selection) {
        let courseDataB = []
        courseDataB = _this.courseData
        selection.length > 0 ? _this.selectionExist(selection, courseDataB) : _this.selectionNoExist(courseDataB)
      }
    },

    selectionExist(selection, courseDataB) {
      let _this = this
      for (var i = 0; i < selection.length; i++) {
        let hasFlg = false
        if (courseDataB.length > 0) {
          for (var l = 0; l < courseDataB.length; l++) {
            //courseDataB[l].courseId === selection[i].courseId ? hasFlg = true : ''
            if (courseDataB[l].courseId === selection[i].courseId) {
              hasFlg = true
            }
          }
        }
        if (!hasFlg) {
          _this.courseData.push(selection[i])
        }
      }
    },
    selectionNoExist(courseDataB) {
      let _this = this
      _this.courseData = []
      if (courseDataB.length > 0) {
        courseDataB.forEach(item => {
          let index = _this.dataList.findIndex(it => it.courseId === item.courseId)
          //index === -1 ? _this.courseData.push(item) : ''
          if (index === -1) {
            _this.courseData.push(item)
          }
        })
      }
    },

    selectRedioExist(selection, row) {
      if (this.isSingleElection && this.courseData.length === 1) {
        this.$refs.coursePlanTable.clearSelection()// 清空
        this.courseData = []
        this.courseData.push(row)
        this.$refs.coursePlanTable.toggleRowSelection(row)// 选择当前行
      } else {
        if (!row) {
          return
        }
        if (!this.courseData) {
          this.courseData.push(row)
          return
        }
        for (var i = 0; i < this.courseData.length; i++) {
          if (String(this.courseData[i].courseId) === String(row.courseId)) {
            this.$message({
              message: this.$t('course.ondb'),
              type: 'warning',
              duration: 3000
            })
            return false
          }
        }
        this.courseData.push(row)
      }
    },


    selectRedioNoExist(selection, row) {
      if (this.isSingleElection && this.courseData.length === 1) {
        this.$refs.coursePlanTable.clearSelection()// 清空
        this.courseData = []
      } else {
        for (let b = 0; b < this.courseData.length; b++) {
          if (row.courseId === this.courseData[b].courseId) {
            this.courseData.splice(b, 1)
            break
          }
        }
      }
    },

    selectRedio: function selectRedio (selection, row) {
      let result = []
      for (let a = 0; a < selection.length; a++) {
        if (row.courseId === selection[a].courseId) {
          result.push(row)
          break
        }
      }

      result.length > 0 ? this.selectRedioExist(selection, row) : this.selectRedioNoExist(selection, row)

      console.log('this.selectCourseTable')
      console.log(this.selectCourseTable)
    },
    backPage () {
      this.$router.go(-1)
    },
    resetCourseData () {
      this.page = 1
      // 将已选场地清空
      this.courseData = []
      this.$refs['dataForm'] && this.$refs['dataForm'].resetFields()
      this.$refs.catalogtree && this.$refs.catalogtree.resetChecked()
      this.$refs.cityclassRef && this.$refs.cityclassRef.resetChecked()
      this.dataForm = {
        courseStatuslist: '20,80',
        courseBaseId: '',
        courseCode: '',
        coursename: '',
        projectCourseFlag: ''
      }
      this.courseData = this.selectCourseTable
      this.brandQuery = []
      this.showCourseCatalogList = []
      this.showCourseCatalogValue = ''
      console.info(this.dataForm)
      console.info(this.showCourseCatalogValue)
      this.$emit('resetCourseData')
      this.getDataList()
    },
    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.page = 1
      this.limit = val
      this.getDataList()
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.page = val
      this.getDataList()
    },
    // 关闭dialog
    closeCourseDlg () {
      this.$emit('closeCourseDlg')
    },
    // 带回主页面
    courseSelectBack () {
      let currSelection = []
      currSelection = this.courseData

      this.$emit('courseSelectBack', currSelection)
      this.courseData = []
    },
    getSelectList (args) {
      let siteClass = []
      args.forEach(function (item) {
        siteClass.push(item.id)
      })
      this.dataForm.siteClassList = siteClass
    },
    // 所属分类的转换
    siteTypeFormatter (row) {
      return Vue.filter('coverEnum')(row.siteType, 'orgType')
    },
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.status, 'status')
    },
    getcitySelectList (args) {
      if (args && args !== '' && args.length > 0) {
        let citySelect = []
        args.forEach(function (item) {
          citySelect.push(item.id)
        })
        this.dataForm.cityClassList = citySelect
      }
    },
    // 生成网格的序号
    indexCreate (index) {
      return (this.page - 1) * this.limit + (index + 1)
    },
    // 查询按钮
    querySiteInfo () {
      this.page = 1
      this.getDataList()
    },
    // 打开页面时，回填勾选
    querSelect () {
      console.log('this.vehicleData')
      console.log(this.courseData)
      if (this.courseData && this.courseData.length > 0) {
        var map = new Map()
        this.courseData.forEach(function (item, index) {
          map.set(item.courseId, item)
        })
        let _this = this
        _this.dataList.forEach(function (dataitem, dataindex) {
          if (map.has(dataitem.courseId)) {
            _this.$refs.coursePlanTable.toggleRowSelection(dataitem)
          }
        })
      }
    },
    // 删除已选场地
    handleClose (data) {
      for (let a = 0; a < this.dataList.length; a++) {
        if (data.courseId === this.dataList[a].courseId) {
          this.$refs.coursePlanTable.toggleRowSelection(this.dataList[a], false)// 选择当前行
          break
        }
      }

      this.courseData.splice(this.courseData.indexOf(data), 1)
    },
    coursestatusformat (row, column, cellValue) {
      if (cellValue === '10') {
        return '未发布'
      } else if (cellValue === '20') {
        return '已发布'
      } else if (cellValue === '30') {
        return '已下架'
      } else { return ' ' }
    },
    coursekindformat (row, column, cellValue) {
      if (cellValue === '10') {
        return '面授课程'
      } else if (cellValue === '20') {
        return '驻店培训'
      } else if (cellValue === '30') {
        return '远程培训'
      } else { return ' ' }
    },
    getTeamRole () {
      let tempArry = []
      for (var val of this.allteamcatalog) {
        if (this.$hasPermission('TEAM:'+val.code)) {
          tempArry.push(val.code)
        }
      }
      if (tempArry.length > 0) {
        this.dataForm.courseTeamCatalogSecond = tempArry.join(',')
      }
    },
    getprojectCourseFlagRole () {
      console.log("getprojectCourseFlagRole   11111111111")
      console.log(this.$hasPermission('learning:offering:trainerOffering'))
      // DOTO 20200303 去掉
      // if (this.$hasPermission('learning:offering:trainerOffering')) {
      //   this.dataForm.projectCourseFlag = '10'
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
/* 隐藏网格的全选按钮 */
/*.jySelectionAll
  > .el-table__header-wrapper
  > .el-table__header
  > thead
  > tr
  > th
  > .cell
  > label {
  display: none !important;
}*/
#gridBox .el-table th {
  background: #ebecf0 !important;
  border-right: 1px #dcdee3 solid;
}
.el-row {
  margin-bottom: 0px;
}
.selectBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .btns {
    display: flex;
    /*width: 193px;*/
    justify-content: flex-end;
  }
}
</style>
